/** @jsxRuntime classic */
/** @jsx jsx */
import { Box } from '@bottlebooks/gatsby-theme-base';
import { jsx } from 'theme-ui';
import ProductSnipcartButton from '../Shop/ProductSnipcartButton';

/** A button to buy via Snipcart. */
export default function ProductRequestSampleWithSnipcartButtonForList({
  product,
  ...rest
}) {
  return (
    <ProductSnipcartButton product={product} data-item-price={0} {...rest} />
  );
}
